import React from 'react'
import PropTypes from 'prop-types'
import DeliveryOption from '../../../components/ProductDetailPage/DeliveryOption'
import { Truck as TruckIcon } from '@walmart-web/livingdesign-icons'
import texts from '../../../common/texts.json'
import constants from '../../../common/constants'

const DeliveryOptionButton = ({ deliveryTags, customClass }) => {
  const hasFreeShipping = deliveryTags.includes(constants.DELIVERY_TAG_KEYS.FREE_SHIPPING)
  const firstLineComponent = texts.PRODUCT_DETAIL.SHIPPING_TO
  const secondLineComponent = hasFreeShipping
    ? texts.PRODUCT_DETAIL.FREE_HOME_DELIVERY
    : texts.PRODUCT_DETAIL.SHORT_HOME_DELIVERY
  const deliveryIcon = <TruckIcon size="small" />

  return (
    <div className={customClass}>
      <DeliveryOption
        image={deliveryIcon}
        firstLineComponent={firstLineComponent}
        secondLineComponent={secondLineComponent}
        theme={{
          firstTextColor: 'black',
          secondTextColor: 'black',
          textSize: '14px',
          fontWeight: 700,
        }}
      />
    </div>
  )
}

DeliveryOptionButton.defaultProps = {
  deliveryTags: [],
  customClass: '',
}

DeliveryOptionButton.propTypes = {
  deliveryTags: PropTypes.array,
  customClass: PropTypes.string,
}

export default DeliveryOptionButton
